module.exports = "#textWidth{\n  width: 100%;\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n#itemLabels{\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n"